import React, { useState, useEffect } from 'react'
import './holiday.css'
import { Link } from 'react-router-dom'
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import {handleOpenModal, handleCloseModal} from '../../../state/modalSlice'
import {handleHoliday} from '../../../state/holidaySlice'
import {addHoliday, getAllHolidays} from '../../../api/holidayApi'
import Loader from '../../../components/loader/Loader'
import ActionCell from '../../../components/actionCell/ActionCell'
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import moment from 'moment'

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);



const columns = [
    {
        field: 'id',
        headerName: 'ID',
        width: 90,
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 300,
    },
    {
        field: 'date',
        headerName: 'Date',
        width: 200,
        renderCell: (param) =>(
            <span>
                {moment(param?.row?.date).format('DD MMMM YYYY')}
            </span>
        )
    },
    {
        field: 'action',
        headerName: 'Action',
        width: 130,
        renderCell: (param) => <ActionCell param={param} />
    },
];


const AddHoliday = ({closeModal, user, modal, handleGetHoliday}) => {
    const [isLoading, setIsLoading] = useState(false)
    const {
        register,
        handleSubmit,
        formState:{errors},
        reset
    } = useForm({
        mode: 'onChange',
        defaultValues: modal?.data ? {...modal?.data} : ''
    })

    const handleSubmitDept = async (data) =>{
        setIsLoading(true)
        try{
            const res = await addHoliday(user?.token, data)
            if(res?.data){
                MySwal.fire({
                    icon: 'success',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 4000
                });
                handleGetHoliday()
                closeModal()
                reset()
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 5000
                });
            }
            setIsLoading(false)
        }catch(error){
            console.log(error)
            setIsLoading(false)
            MySwal.fire({
                icon: 'error',
                title: "There's an error processing your request, Try again",
                showConfirmButton: false,
                timer: 5000
            });
        }
    }

    return (
        <div className="modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
                <div className="modal-heading">
                    <h4 className="modal-title">Add Holiday</h4>
                    <button type='button' onClick={closeModal}
                    className="modal-btn">
                        <i class='bx bx-x'></i>
                    </button>
                </div>
                <form className="modal-form" onSubmit={handleSubmit(handleSubmitDept)}>
                    <div className="modal-field">
                        <label htmlFor="name" className='modal-label'>
                            Name <span>*</span>
                        </label>
                        <input type="text" name='name' className="modal-input" 
                        {...register('name',{required: 'This field is required!'})}/>
                        {errors.name && <span className="modal-error">
                            {errors?.name?.message}
                        </span>}
                    </div>
                    <div className="modal-field">
                        <label htmlFor="date" className='modal-label'>
                            Date <span>*</span>
                        </label>
                        <input type="date" name='date' className="modal-input" 
                        {...register('date',{required: 'This field is required!'})}/>
                        {errors.date && <span className="modal-error">
                            {errors?.date?.message}
                        </span>}
                    </div>

                    <div className="modal-field">
                        {
                            isLoading ? <Loader/> : <button type='submit'
                            className='modal-button button'>
                                Add Holiday
                            </button>
                        }
                    </div>
                </form>

            </div>
        </div>
    )
}


const Holiday = () => {
    const {user} = useSelector((state)=>state.user)
    const {modal} = useSelector((state)=>state.modal)
    const {holiday} = useSelector((state)=>state.holiday)
    const [value, setValue] = useState('')
    const dispatch = useDispatch()


    const openModal = () => {
        dispatch(handleOpenModal())
    }

    const closeModal = () => {
        dispatch(handleCloseModal())
    }

    const handleGetHoliday = async () =>{
        try{
            const res = await getAllHolidays(user?.token)
            dispatch(handleHoliday(res?.data))
        }catch(error){
            console.log(error)
        }
    }

    const filterItems = holiday?.filter((item)=>{
        return item?.name?.toLowerCase()?.includes(value.toLowerCase())    })

    useEffect(()=>{
        handleGetHoliday()
    },[])

  return (
    <section className='department'>
        {/* HEADING */}
        <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">All Holiday | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                        Holiday <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                    All Holidays
                </p>
            </div>
            <button 
            onClick={openModal}
            className="heading__box-btn button">
                Add Holiday
            </button>
        </div>

        <div className="department__container">
            <div className="department__items">
                <div className="department__search">
                    <h4 className="department__search-title">Holidays</h4>
                    <div className="department__search-box">
                        <span className="department__search-span">Search:</span>
                        <input type="text" placeholder="Name..."
                        value={value} onChange={(e)=>setValue(e.target.value)}
                        className='department__search-input'/>
                    </div>
                </div>

                <div className="department__table">
                    <DataGrid
                        // getRowId={(rows => rows._id)}
                        rows={filterItems?.map((item, i)=>({
                            id: i + 1,
                            ...item
                        })) ?? []}
                        columns={columns}
                        initialState={{
                        pagination: {
                            paginationModel: {
                            pageSize: 5,
                            },
                        },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection
                        disableRowSelectionOnClick
                        getRowHeight={() => 'auto'} 
                        sx={{
                            margin: 'auto',                        
                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                                py: 0.5,
                            },
                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                                py: '5px',
                            },
                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                                py: '10px',
                            },
                        }}
                        experimentalFeatures={{ lazyLoading: true }}
                    />
                </div>
            </div>
        </div>
        {modal?.show && <AddHoliday 
        modal={modal}
        user={user}
        closeModal={closeModal}
        handleGetHoliday={handleGetHoliday}/>}
    </section>
  )
}

export default Holiday